<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.25,23.251c-1.241,0-2.25-1.009-2.25-2.25V10.5C0,9.673,0.673,9,1.5,9V2.25c0-0.414,0.336-0.75,0.75-0.75h4.5
		c0.827,0,1.5,0.673,1.5,1.5v2.25c0,0.827-0.673,1.5-1.5,1.5H3V9c0.827,0,1.5,0.673,1.5,1.5v0.75H6V10.5C6,9.673,6.673,9,7.5,9H9
		c0.827,0,1.5,0.673,1.5,1.5v0.75H12V10.5C12,9.673,12.673,9,13.5,9H15c0.827,0,1.5,0.673,1.5,1.5v2.25H18V6
		c0-0.017,0.003-0.051,0.005-0.068c0-0.016,0.003-0.043,0.009-0.07c0.003-0.018,0.009-0.041,0.016-0.063
		c0.005-0.02,0.01-0.041,0.019-0.062l1.55-4.127c0.221-0.58,0.785-0.969,1.404-0.969c0.182,0,0.361,0.033,0.531,0.098
		c0.399,0.152,0.716,0.468,0.868,0.868l1.551,4.13c0.006,0.017,0.015,0.049,0.019,0.066c0.005,0.014,0.011,0.039,0.016,0.065
		c0.004,0.021,0.007,0.048,0.009,0.075C23.998,5.955,24,5.977,24,6v15.5c0,0.965-0.785,1.75-1.75,1.75H2.25z M22.25,21.751
		c0.138,0,0.25-0.112,0.25-0.25V6.75h-3v15H22.25z M18,21.751v-7.5h-1.5v7.5H18z M15,21.751V10.5h-1.5v0.75
		c0,0.827-0.673,1.5-1.5,1.5h-1.5c-0.827,0-1.5-0.673-1.5-1.5V10.5H7.5v0.75c0,0.827-0.673,1.5-1.5,1.5H4.5
		c-0.827,0-1.5-0.673-1.5-1.5V10.5H1.5v10.5c0,0.414,0.336,0.75,0.75,0.75h3v-3.75c0-1.654,1.346-3,3-3s3,1.346,3,3v3.75H15z
		 M9.75,21.751v-3.75c0-0.827-0.673-1.5-1.5-1.5s-1.5,0.673-1.5,1.5v3.75H9.75z M22.167,5.25L21,2.143L19.833,5.25H22.167z
		 M6.75,5.25V3H3v2.25H6.75z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'historical-building-castle-1',
    },
    name: {
      type: String,
      required: false,
      default: 'HistoricalBuildingCastle1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>